import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { StarRatingComponent } from 'ng-starrating';
import { MatBottomSheet, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { IPhoneCall } from '@wephone-app-phone/services';
import { CdrService } from '@wephone-core/service/cdr_service';
import { FlexBaseComponent } from '@wephone-core-ui';
import { MessageService } from '@wephone-utils';

@Component({
  selector: 'bottom-sheet-call-quality-evaluation',
  templateUrl: './bottom-sheet-call-quality-evaluation.component.html',
  styleUrls: ['./bottom-sheet-call-quality-evaluation.component.scss']
})
export class BottomSheetCallQualityEvaluationComponent extends FlexBaseComponent implements OnInit, OnDestroy {
  ratedValue: number;
  isRated = false;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) private data: IPhoneCall,
    private cdrService: CdrService,
    private bottomSheet: MatBottomSheet,
    private messageService: MessageService,
    cdr: ChangeDetectorRef,
  ) {
    super(cdr);
    // this.loggerService.log('BottomSheetCallQualityEvaluationComponent', data);
  }

  get userCallId(): number {
    return this.data && this.data.calldata && this.data.calldata.user_call_id;
  }

  get callQueueSessionId(): number {
    return this.data && this.data.calldata && this.data.calldata.call_queue_session_id;
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.addSubscription(
      this.messageService.subscribeQualificationDone((event: {
        callqueue_session_id: number;
        type: 'audio'|'call'
      }) => {
        // this.loggerService.log('subscribe qualification done event', event);
        // this.loggerService.log('this.callQueueSessionId', this.callQueueSessionId);
        // this.loggerService.log('this.userCallId', this.userCallId);
        if (this.callQueueSessionId === event.callqueue_session_id && event.type === 'audio') {
          // this.loggerService.log('Matched callQueueSessionId, close bottom-sheet');
          this.bottomSheet.dismiss();
        }
      })
    );

  }

  // Need to unsubscribe event
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  async onRate(event: { oldValue: number, newValue: number, starRating: StarRatingComponent }): Promise<any> {
    if (event.newValue && event.newValue !== event.oldValue) {
      const data = {
        id: this.userCallId,
        callqueue_session_id: this.callQueueSessionId,
        quality_note: event.newValue
      };
      try {
        await this.cdrService.updateCallQualityEvaluation(data);
        this.ratedValue = event.newValue;
        this.isRated = true;
        this.detectChanges();
      } catch (e) {
        this.loggerService.error('Error rate', e);
      }
    }
  }

}
